import { BaseButton } from '@systemeio/ui'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { emailSelectors, managementSelectors, useEmail, useTypedSelector } from '../../../store'
import * as managementActions from '../../../store/management/actions'

const OpenSettings = () => {
  const { t } = useTranslation()
  const isSettingsEditing = useTypedSelector(state =>
    managementSelectors.isGlobalSettingsEditing(state.management),
  )
  const dispatch = useDispatch()
  function toggleSettings() {
    dispatch(managementActions.toggleGlobalSettingsEditing())
  }

  const settings = useEmail(emailSelectors.getSettings)
  const hasSettings = Object.keys(settings).length > 0
  return (
    <BaseButton
      disabled={!hasSettings}
      color={
        hasSettings
          ? isSettingsEditing
            ? 'text-brand-primary'
            : 'text-text-primary'
          : 'text-background-secondary'
      }
      hoverColor={isSettingsEditing ? 'hover:text-brand-primary' : 'hover:text-brand-primary'}
      backgroundColor={hasSettings ? 'bg-background-secondary' : 'bg-text-secondary/50'}
      hoverBackgroundColor={'hover:bg-background-secondary'}
      borderColor={isSettingsEditing ? 'border-brand-primary' : 'border-text-secondary/30'}
      hoverBorderColor={'hover:border-brand-primary'}
      type={'button'}
      onClick={toggleSettings}
    >
      {t('core.header.settings.title')}
    </BaseButton>
  )
}

export default OpenSettings
